import React, { Component } from 'react';
import { Icon } from 'ui';
import Tag from './Tag';

class TagsList extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggleList = this.toggleList.bind(this);
  }

  static defaultProps = {
    collapseAt: 4,
  };

  static CollapseButton({ onClick, children, icon }) {
    return (
      <button type="button" className="u-linkBtn p-4" onClick={onClick}>
        {children}
        <Icon name={icon} className="ml-4 fz-xs" />
      </button>
    );
  }

  get tagsCount() {
    return this.props.taggings.length;
  }

  renderExpandButton() {
    const { collapseAt } = this.props;
    const Btn = props =>
      TagsList.CollapseButton({ ...props, onClick: this.toggleList });
    if (this.tagsCount <= collapseAt) return false;
    if (this.state.expanded) return <Btn icon="triangle_up">Show fewer</Btn>;
    return (
      <Btn icon="triangle_down">
        Show {this.tagsCount - (collapseAt - 1)} More
      </Btn>
    );
  }

  toggleList() {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  getTaggings() {
    const { taggings, collapseAt } = this.props;
    if (this.state.expanded || this.tagsCount <= collapseAt) return taggings;
    return taggings.slice(0, collapseAt - 1);
  }

  renderAddTagButton() {
    return (
      <button
        type="button"
        className="u-linkBtn fz-base fw-n"
        onClick={this.props.toggleEditing}
      >
        <Icon name="add" className="mr-4" />
        Add Tag
      </button>
    );
  }

  renderTags() {
    return this.getTaggings().map(tagging => {
      const tag = this.props.getTag(tagging);
      return <Tag key={tag.id} {...tag} />;
    });
  }

  renderBody() {
    if (this.tagsCount !== 0) return this.renderTags();
    if (this.props.viewOnly) return <BlankSlate />;
    return this.renderAddTagButton();
  }

  render() {
    return (
      <div>
        {this.renderBody()}
        {this.renderExpandButton()}
      </div>
    );
  }
}

const BlankSlate = () => <span className="c-brand-gray-darker">No Tags</span>;

export default TagsList;
